export enum RegisterStage {
  'STEP1' = 1,
  'STEP2',
  'STEP3',
  'STEP4',
  'IMPORT',
}
